
import * as authConfig from  './authConfig';



const IntLivDict = {
    orgCode: process.env.REACT_APP_IntLivOrgCode,
    config: authConfig.IntLivConfig
}


/***
 * 1. testInstance is for testing single tenant on staging, need to be removed before push to master
 * 2. when adding new instance, need to config .env / .env.staging / .env.production. 
 *      Attention*^o^* if not configured in .env.staging or .env.production, will fallback to .env config
 *      so if production config is not determined, just put empty config so that won't fallback
 */



// ** Remember to add config to ausmed-cpd -> my-org-sso-redirect **
export const PathToDict = {
    'integratedliving': IntLivDict,
}










